import React, { Component, PropTypes } from "react";
import { Image, TouchableOpacity, Animated, View } from "react-native";
import TextView from "./TextView";
import { icons } from "../theme/icons";
import { styles, componentStyles, appStyles } from "../theme/styles";
import { showPrompt } from "../utils/utils";

export default class FavortiPersonItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var item = this.props.data;
        return (
            <View style={componentStyles.favoirtPersonItem}>
                <Image source={icons['avatar']} style={componentStyles.favoritPersonIcon} />
                <TextView>{item.flname}</TextView>
                <View style={componentStyles.actionFavoritWraper}>
                    <TouchableOpacity style={componentStyles.removeButtonWraper} onPress={() => {
                        showPrompt('حذف شخص منتخب', 'آیا میخواهید این آیتم را حذف نمایید؟', () => {
                            this.props.onRemove();
                        })
                    }}>
                        <TextView style={{ color: 'white', fontSize: 10 }}>حذف</TextView>
                        <Image source={icons['remove']} style={[componentStyles.smallIconWhite, { marginLeft: 1 }]} />
                    </TouchableOpacity>
                    <TouchableOpacity style={componentStyles.editButtonWraper} onPress={() => {
                        this.props.navigation.navigate('createFavoritPerson', {
                            data: this.props.data,
                            refresh: () => this.props.onRefresh()
                        })
                    }}>
                        <TextView style={{ color: 'white', fontSize: 10 }}>ویرایش</TextView>
                        <Image source={icons['edit']} style={[componentStyles.smallIconWhite, { marginLeft: 1 }]} />
                    </TouchableOpacity>

                </View>
            </View>
        );
    }
}


